import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import axiosConfig from "../../../services/Axios";
import Select from "react-select";
import SelectTheme from "./SelectTheme";
import { useTranslation } from "react-i18next";

const SelectOrderStates = ({
  onChange,
  cancelToken = null,
  className,
  value = null,
}) => {
  const [options, setOptions] = useState();
  const [selectedValue, setSelectedValue] = useState(null);
  const { t } = useTranslation();
  const authUser = useSelector((state) => state.auth);
  const isAdmin = authUser?.user?.roles.includes("ROLE_ADMIN");

  const fetchRoles = useCallback(async (token) => {
    return await axiosConfig
      .get(
        process.env.REACT_APP_API_URL +
          "/api/purchase_orders/available_states?pagination=false",
        {
          cancelToken: token,
        }
      )
      .then((response) => {
        let states = [];
        response.data["hydra:member"].map((state) => {
          let opt = {};

          if (isAdmin || state !== "in_progress") {
            opt = {
              value: state,
              label: t("settings.orders.state." + state.toLowerCase()),
            };
            states.push(opt);
          }

          if (state === value) {
            setSelectedValue(opt);
          }
        });

        return states;
      })
      .catch(function (thrown) {
        if (axiosConfig.isCancel(thrown)) {
          console.log("ItemStates Request canceled : ", thrown.message);
        }
      });
  }, []);

  useEffect(() => {
    fetchRoles(cancelToken).then((response) => {
      setOptions(response);
    });
  }, [cancelToken]);

  return (
    <>
      <Select
        isSearchable={false}
        options={options}
        value={selectedValue}
        defaultValue={value}
        onChange={(e) => {
          onChange(e.value);
          setSelectedValue(e);
        }}
        className={`${className} w-full`}
        theme={SelectTheme}
      />
    </>
  );
};

export default SelectOrderStates;
